import { CheckMarkIcon } from '@/assets/CheckMarkIcon';
import { RightArrow } from '@/assets/RightArrow';
import { useEffect } from 'react';
import HalftoneContainer from '@/components/HalftoneContainer';

export const FormThankYou = ({
  userName,
  formVariant,
}: {
  userName: string;
  formVariant: string;
}) => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submission_success',
      form_type: formVariant,
      user_name: userName,
    });
    window.history.pushState(
      {},
      '',
      `/get-started/thank-you?utm_form=${formVariant}`,
    );
  }, [userName, formVariant]);

  return (
    <HalftoneContainer className="min-h-screen md:px-8 px-5 pt-14 flex flex-col items-center justify-center">
      <div
        className={`rounded-full flex items-center justify-center relative z-10 text-lg
                           bg-gradient-to-b from-primary-green-shade to-primary-green text-white w-12 h-12 before:content-[''] before:absolute before:rounded-full before:border-4 before:border-white before:p-[18px] p-[0.9rem] scale-150 mb-6`}
      >
        <CheckMarkIcon></CheckMarkIcon>
      </div>
      <br />
      <p className="font-bold text-center text-xl">Thanks, {userName}!</p>
      <br />
      <p className="text-lg text-center max-w-3xl">
        {
          "We'll reach  out shortly with the best matches based on your requirements."
        }
      </p>
      <p className="text-lg text-center max-w-2xl">
        In the meantime, feel free to explore our resources here.
      </p>
      <br />
      <a
        href="https://devsu.com/clients"
        className={`px-8 py-5 text-white rounded-full font-semibold flex justify-between items-center bg-primary-green text-xl`}
      >
        View case studies{' '}
        <span className="ml-2">
          <RightArrow />
        </span>
      </a>
    </HalftoneContainer>
  );
};
